export const textContentToJSON = <T>(
  content: string | undefined | null,
): T | null => {
  let t = null;
  if (content) {
    try {
      t = JSON.parse(content) as T;
      // eslint-disable-next-line no-empty, sonarjs/no-ignored-exceptions
    } catch (_) {}
  }
  return t;
};
